<template>
	<div v-loading.fullscreen.lock="visible.loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><i class="icon-lx-calendar"></i> 待办业务</el-breadcrumb-item>
				<el-breadcrumb-item>待办人员</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<div class="container">
			<el-row>
				<el-col :span="5">
					<div class="handle-box">
						<el-input placeholder="单位名称" suffix-icon="el-icon-search" v-model.lazy="data.filterDeptStr"
							@change="filterDept" size="large" clearable>
							<el-checkbox slot="prepend" v-model="data.containSubEmployee"
								@change="changeContainSubEmployee">包含下级</el-checkbox>
						</el-input>
					</div>
					<div style="max-height:600px;overflow:auto;">
						<el-tree ref="depts" :data="data.depts" node-key="id" :check-on-click-node="true"
							highlight-current :expand-on-click-node="false" @node-click="handleDeptNodeClick"
							:filter-node-method="handleTreeFilter">
							<span class="span-ellipsis" slot-scope="{ node, data }">
								<span :title="node.label">{{ node.label }}</span>
							</span>
						</el-tree>
					</div>
				</el-col>
				<el-col :span="1">
					&nbsp;
				</el-col>
				<el-col :span="18">
					<div class="handle-box left">
						<el-input v-model="data.filterstr" placeholder="姓名/身份证" size="large" style="width:350px;"
							@change="search(true)">
							<el-button slot="append" type="primary" icon="if-lcon-duqushenfenzheng"
								@click="readFromIdCardReader"></el-button>
						</el-input>
						<el-button class="ml10" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
					</div>
					<div class="handle-box right">
						<el-button ref="handle" class="ml10" type="primary" icon="el-icon-edit-outline"
							@click="toHandle" v-if="power.handle" :disabled="data.curEmpId == 0">受理
						</el-button>
						<el-popconfirm title="是否删除该待办信息？" v-if="power.remove" @confirm="removeApply">
							<el-button ref="remove" class="ml10" type="danger" icon="el-icon-delete" slot="reference"
								:disabled="data.curEmpId == 0">删除
							</el-button>
						</el-popconfirm>
					</div>

					<el-table ref="table" :data="data.rows" border class="table" row-key="id" highlight-current-row
						@current-change="tableCurrentChange">
						<el-table-column prop="personType" label="类别" width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.personType==1">员工</span>
								<span v-else-if="scope.row.personType==2">保运</span>
								<!--<span v-else-if="scope.row.personType==3">外协常驻</span>-->
								<span v-else-if="scope.row.personType==4">外协</span>
								<span v-else>-</span>
							</template>
						</el-table-column>
						<el-table-column prop="applyDate" label="推送日期" width="150">
						</el-table-column>
						<el-table-column prop="deptName" label="单位" width="180" show-overflow-tooltip>
						</el-table-column>
						<el-table-column prop="name" label="姓名" width="110">
						</el-table-column>
						<el-table-column prop="code" label="人员编号" width="150">
						</el-table-column>
						<el-table-column prop="idno" label="身份证号" width="280">
						</el-table-column>
						<el-table-column prop="valid" label="有效期" width="450">
							<template slot-scope="scope">
								{{ scope.row.validStart }} 至 {{ scope.row.validEnd }}
							</template>
						</el-table-column>
						<el-table-column prop="doorPost" label="权限组" width="120">
						</el-table-column>
						<el-table-column prop="type" label="类型" width="140">
							<template slot-scope="scope">
								<el-tag v-if="scope.row.type == 0" type="success" size="large">新办</el-tag>
								<el-tag v-else-if="scope.row.type == 1" type="primary" size="large">变更</el-tag>
								<el-tag v-else-if="scope.row.type == 2" type="danger" size="large">存在</el-tag>
							</template>
						</el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentPageChange"
							:current-page="data.page" :page-sizes="[10,20,50,100,200,300,400,500]"
							:page-size="data.size" layout="total, sizes, prev, pager, next, jumper" :total="data.total">
						</el-pagination>
					</div>
				</el-col>
			</el-row>
		</div>

		<el-dialog title="人员待办受理" :visible.sync="visible.handle" v-if="power.handle && visible.handle" width="1280px"
			center :close-on-click-modal="false">
			<div style="height:640px;">
				<el-row>
					<el-steps :active="data.handle.step" finish-status="success">
						<el-step title="信息核验"></el-step>
						<el-step title="制卡"></el-step>
						<el-step title="读取国密卡"></el-step>
						<el-step title="鉴权"></el-step>
						<el-step title="消费配置"></el-step>
						<el-step title="办理完成"></el-step>
					</el-steps>
				</el-row>
				<div>&nbsp;</div>
				<el-form @submit.native.prevent label-width="140px">
					<el-row v-if="data.handle.step == 0">
						<el-row>
							<el-col :span="12">
								<el-form-item label="证件编号:">
									<el-input v-model="data.info.code" size="large" readonly></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4">&nbsp;
							</el-col>
							<el-col :span="8">
								<el-checkbox v-if="setting.canOnlyFace" v-model="data.handle.onlyFace">仅发人脸</el-checkbox>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="身份证:">
									<el-input v-model="data.info.idno" size="large" readonly 
										:class="data.info.hasEmp ? 'red' : ''"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:blue;display:inline-block;"
									v-if="data.info.hasEmp">该身份证在系统中已存在</span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="姓名:">
									<el-col :span="12"><el-input v-model="data.info.name" size="large" readonly
											:class="data.info.sameName || !data.info.name1 ? '' : 'red'"></el-input></el-col>
									<el-col :span="12"><el-input v-model="data.info.name1" size="large" readonly
											v-if="!data.info.sameName"></el-input></el-col>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:red;display:inline-block;"
									v-if="!data.info.sameName && data.info.name1">注：姓名不一致，请审核<el-checkbox
										v-model="data.handle.canCheckData1">同意继续办理</el-checkbox></span>
							</el-col>
						</el-row>
						<el-row v-if="data.info.hasEmp && data.info.diffDept">
							<el-col :span="12">
								<el-form-item label="原单位:">
									<el-input v-model="data.info.oldDept" size="large" readonly></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="单位:">
									<el-input v-model="data.info.realDeptName" size="large" readonly
										:class="data.info.hasEmp && data.info.diffDept ? 'red' : ''"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:red;display:inline-block;"
									v-if="data.info.hasEmp && data.info.diffDept">注：单位已变更，请审核<el-checkbox
										v-model="data.handle.canCheckData2">同意继续办理</el-checkbox></span>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item label="类别:">
									<el-col :span="12"><el-input v-model="data.info.personTypeName" size="large"
											readonly
											:class="data.info.sameName || !data.info.name1 ? '' : 'red'"></el-input></el-col>
									<el-col :span="12"><el-input v-model="data.info.oldPersonTypeName" size="large"
											readonly v-if="!data.info.hasEmp && data.info.diffType"></el-input></el-col>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<span style="color:red;display:inline-block;"
									v-if="data.info.hasEmp && data.info.diffType">注；类别已变更，请审核<el-checkbox
										v-model="data.handle.canCheckData3">同意继续办理</el-checkbox></span>
							</el-col>
						</el-row>
						<el-form-item label="人脸照片:">
							<div style="height:200px;width:100%;">
								<el-row>
									<el-col :span="8">
										<img :src="data.handle.img"
											style="height:200px;width:100%;object-fit:contain;" />
									</el-col>
									<el-col :span="7">
										<el-button type="primary" @click="cameraImage"
											style="width:200px;margin:2px 2px 2px 10px;">拍照</el-button>
										<el-button type="primary" @click="loadLocationImage"
											style="width:200px;margin:2px 2px 2px 10px;">本地上传</el-button>
										<el-button type="primary" @click="loadFaceSvcImage"
											style="width:200px;margin:2px 2px 2px 10px;">脸谱读取</el-button>
										<el-button type="primary" @click="toCropper"
											style="width:200px;margin:2px 2px 2px 10px;">图片裁剪</el-button>
									</el-col>
									<el-col :span="9">
										<!--<el-checkbox v-model="data.handle.saveFaceSvc">保存时覆盖脸谱图片</el-checkbox><br /><br />-->
										注：界面首次打开，<br />
										系统自动获取用户脸谱照片，<br />
										如需更换请按左侧按钮进行更替与确认。
									</el-col>
								</el-row>
							</div>
						</el-form-item>
					</el-row>
					<el-row v-if="data.handle.step == 1">
						<div style="text-align:center;width:600px;height:300px;margin:auto;position:relative;">
							<div v-if="data.info.personType == 1">
								<img src="/image/yuangong.png" width="500" height="310" />
								<img :src="'/im/FacePic/' + data.info.idno + data.info.name + '.jpg'"
									style="position:absolute;left:90px;top:80px;" width="140" height="210" />
								<label
									style="position:absolute;top:170px;left:350px;font-weight:500;color:black;">{{data.info.name}}</label>
								<label
									style="position:absolute;top:214px;left:350px;font-weight:500;color:black;">{{data.info.code}}</label>
							</div>
							<div v-else-if="data.info.personType == 2 || data.info.personType == 4">
								<img :src="'/image/' + (data.info.personType == 2 ? 'baoyun' : 'waixie' ) + '.png'"
									width="500" height="310" />
								<img :src="'/im/FacePic/' + data.info.idno + data.info.name + '.jpg'"
									style="position:absolute;left:90px;top:80px;" width="140" height="210" />
								<label
									style="position:absolute;top:170px;left:350px;font-weight:500;color:black;">{{data.info.name}}</label>
								<label
									style="position:absolute;top:240px;left:350px;font-weight:500;color:black;">{{data.info.code}}</label>
								<label
									style="position:absolute;top:214px;left:350px;font-weight:500;color:black;font-size:14px !important;">{{data.info.realDeptName}}</label>
							</div>
						</div>
					</el-row>
					<el-row v-if="data.handle.step == 2">
						<div style="text-align:center;width:600px;height:300px;margin:auto;position:relative;">
							<img src="../../assets/img/toCard.png" width="300"
								style="display:block;margin:auto;margin-top:100px;" />
							<img src="../../assets/img/ok.png" width="50" v-if="data.handle.cardTxtFocusStatus"
								style="position:absolute;top:-20px;right:160px;" />
							<img src="../../assets/img/warning.png" width="50" @click="toFocusCardTxt" v-else
								style="position:absolute;top:-20px;right:160px;" />
							<el-form-item label="当前卡号:" style="position:absolute;top:-999px;">
								<input ref="txtCardId" v-model="data.info.cardId" @blur="blurCardTxt"
									@focus="focusCardTxt" @keyup.enter="handleCardChange" />
								<input ref="txtCardNo" v-model="data.info.cardNo" @blur="blurCardTxt"
									@focus="focusCardTxt" @keyup.enter="handleCardChange" />
							</el-form-item>
							<div style="text-align:left;width:500px;margin-left:100px;">
								当右上角存在红色图标时，请点击红色图标，<br />当右上角存在绿色图标时，可刷卡，<br />完成刷卡后可点击下一步按钮进行鉴权。
							</div>
						</div>
					</el-row>
					<el-row v-if="data.handle.step == 3">
						<el-form-item label="单位:">
							<el-input v-model="data.info.realDeptName" size="large" readonly></el-input>
						</el-form-item>
						<el-form-item label="姓名:">
							<el-input v-model="data.info.name" size="large" readonly></el-input>
						</el-form-item>
						<el-form-item label="门禁权限:">
							<el-table ref="authorize" border class="inner-authorize-table" :data="data.authorizeDatas">
								<el-table-column prop="label" label="" width="100" align="right"></el-table-column>
								<el-table-column v-for="(item,index) in data.authorizeGroups" :prop="'c-' + item.id"
									:key="item.id" :label="item.name" width="120" header-align="center" align="center">
									<template slot-scope="scope">
										<input type="checkbox" style="width:30px;height:30px;"
											:checked="data.authorizeChecks[scope.$index][index]"
											:disabled="scope.$index == 2 && !data.info.hasVehicle"
											@change="changeAuthorizeChecked" :name="scope.$index + '_' + index" />
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
					</el-row>
					<el-row v-if="data.handle.step == 4">
						<el-form-item label="消费:">
							<el-radio-group v-model="data.handle.canPos" @change="changeCanPos">
								<el-radio-button :label="true">开通</el-radio-button>
								<el-radio-button :label="false">不开通</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="西太云餐:">
							<el-radio-group v-model="data.handle.canMobilePos" :disabled="!data.handle.canPos">
								<el-radio-button :label="true">开通</el-radio-button>
								<el-radio-button :label="false">不开通</el-radio-button>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="手机号:">
							<el-input v-model="data.handle.mobilePhone" size="large"></el-input>
						</el-form-item>
					</el-row>
					<el-row v-if="data.handle.step == 6">
						<div style="text-align:center;width:600px;height:300px;margin:auto;">
							<img src="../../assets/img/ok.png" width="120px"
								style="display:block;margin:auto;margin-top:100px;" />
							人员信息办理完成，请点击右下方按钮结束操作。
						</div>
					</el-row>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button ref="btnFinishCheckData" class="right" type="primary" @click="finishCheckData"
					v-if="data.handle.step == 0"
					:disabled="!data.handle.canCheckData1 || !data.handle.canCheckData2 || !data.handle.canCheckData3">下一步
				</el-button>
				<el-button ref="btnBackToCheckData" class="left" type="infor" @click="backToCheckData"
					v-if="data.handle.step == 1">上一步
				</el-button>
				<el-button ref="btnSkipPrint" class="right" type="primary" @click="finishPrint"
					v-if="data.handle.step == 1">跳过打卡
				</el-button>
				<el-button ref="btnToPrint" class="right" type="primary" @click="toPrint"
					v-if="data.handle.step == 1">开始打卡
				</el-button>
				<el-button ref="btnFinishReadCard" class="right" type="primary" @click="finishReadCard"
					v-if="data.handle.step == 2" :disabled="isNaN(data.info.cardNo) || (!data.info.cardNo)">下一步
				</el-button>
				<el-button ref="btnBackToCheckData" class="left" type="infor" @click="backToPrint"
					v-if="data.handle.step == 2">上一步
				</el-button>
				<el-button ref="btnFinishAuthorize" class="right" type="primary" @click="finishAuthorize"
					v-if="data.handle.step == 3">下一步</el-button>
				<el-button ref="btnBackToReadCard" class="left" type="infor" @click="backToReadCard"
					v-if="data.handle.step == 3">上一步
				</el-button>
				<el-button class="left" type="infor" @click="backToAcsAuthorize" v-if="data.handle.step == 4">上一步
				</el-button>
				<el-button ref="btnFinishAuthorize" class="right" type="primary" @click="saveData"
					v-if="data.handle.step == 4">保存数据
				</el-button>
				<el-button ref="btnDoPrintCard" class="right" type="primary" @click="visible.handle = false"
					v-if="data.handle.step == 6">完成</el-button>
				<!--<el-button type="danger" @click="toCancel" v-if="data.handle.step < 4">取消</el-button>
				<el-button type="infor" @click="toCancel" v-else>关闭</el-button>-->
			</div>
		</el-dialog>

		<el-dialog title="打印预览" :visible.sync="visible.print" v-if="power.handle" width="510px" center
			:close-on-click-modal="false">
			<div id="printCardTemplate">
				<iframe ref="template1" :srcdoc="data.print.template1" width="468px" height="276px" frameborder="0"
					scrolling="no"></iframe>
			</div>
		</el-dialog>

		<takeImage ref="takeImage" @toOk="saveImage" :autoCropWidth="270" :autoCropHeight="378"></takeImage>
		<takeCamera ref="takeCamera" @toOk="saveImage" :autoCropWidth="270" :autoCropHeight="378"></takeCamera>
	</div>
</template>

<script>
	import takeImage from '../usercontrol/TakeImage.vue'
	import takeCamera from '../usercontrol/TakeCamera.vue'
	export default {
		name: 'emprehandle',
		data() {
			return {
				data: {
					depts: [],
					filterstr: '',
					total: 0,
					size: 10,
					page: 1,
					rows: [],
					filterDeptStr: '',
					curDeptId: '0',
					containSubEmployee: true,
					curEmpId: 0,
					info: {
						id: 0,
						name: '',
						code: '',
						idno: '',
						deptId: 0,
						deptName: '',
						realDeptName: '',
						hasVehicle: false,
						doorPost: '',
						personType: 0,
						personTypeName: '',
						oldPersonTypeName: '',
						cardNo: '',
						cardId: '',
						sameName: false,
						hasEmp: false,
						diffDept: false,
						diffType: false
					},
					handle: {
						step: 0,
						onlyFace: false,
						power: [],
						passType: [],
						cardTxtFocusStatus: false,
						img: '',
						//0 - 拍照，   1 - 本地，   2 - 脸谱
						imgType: 0,
						saveFaceSvc: true,
						mobilePhone: '',
						canPos: false,
						canMobilePos: false,
						canCheckData1: true,
						canCheckData2: true,
						canCheckData3: true
					},
					print: {
						template1: '',
						template2: '',
						noneprintbutton: false
					},
					printFrameStatus: {
						checkAllComplateTimer: null,
						pic1IsComplate: false,
						pic2IsComplate: false
					},
					authorizeHeader: {},
					authorizeGroups: [],
					authorizeDatas: [],
					authorizeChecks: []
				},
				setting: {
					canOnlyFace: false,
				},
				visible: {
					loading: false,
					handle: false,
					print: false,
					takeImage: false,
					takeCamera: false
				},
				power: {
					pageId: 24,
					search: false,
					handle: false,
					print: false,
					remove: false
				}
			}
		},
		methods: {
			readFromIdCardReader() {
				let ths = this;
				ths.dev.gethsidcardreader(ths, 'data.filterstr', 'visible.loading', v => {
					ths.search(true);
				});
			},
			search(change) {
				let ths = this;
				ths.loading = false;
				if (ths.$refs.table) {
					ths.$refs.table.setCurrentRow(false);
				}
				ths.data.curEmpId = 0;
				if (change) {
					ths.data.page = 1;
				}
				window.ax.get('api/rehandle/employee/list?id=' + ths.data.curDeptId + '&pagesize=' + ths.data.size +
					'&currentpage=' + ths.data.page + '&sign=' + window.$gloable.userinfo.sign + '&filterStr=' + ths
					.data.filterstr + '&idstr=' + (ths.data.containSubEmployee ? '1' : '0')).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						data = data.data;
						let len = data.datas.length;
						let total = data.totalRecord;
						ths.data.rows = data.datas;
						ths.data.total = total;
						if (len == 0 && total > 0) {
							ths.data.page = Math.ceil(total / ths.data.size);
							ths.search();
						}
					} else {
						ths$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			tableCurrentChange(row) {
				this.data.curEmpId = row.id;
			},
			handleSizeChange(size) {
				this.data.size = size;
				this.data.page = 1;
				this.search();
			},
			handleCurrentPageChange(current) {
				this.data.page = current;
				this.search();
			},
			changeContainSubEmployee() {
				this.search(true);
			},
			filterDept() {
				this.data.filterDeptStr = this.data.filterDeptStr.toLowerCase();
				this.$refs.depts.filter(this.data.filterDeptStr);
			},
			handleDeptNodeClick(data, node, target) {
				let ths = this;
				if (ths.data.curDeptId != data.id) {
					ths.data.curDeptId = data.id;
					ths.data.filterstr = '';
					ths.search(true);
				}
			},
			handleTreeFilter(value, data, node) {
				if (!value) {
					return true;
				} else {
					return data.label && data.label.toLowerCase().indexOf(value) != -1;
				}
			},
			toHandle() {
				let ths = this;
				if (ths.data.curEmpId > 0) {
					ths.$refs.handle.$el.blur();
					ths.visible.loading = true;
					ths.data.handle.canCheckData1 = true;
					ths.data.handle.canCheckData2 = true;
					ths.data.handle.canCheckData3 = true;
					window.ax.get('api/rehandle/employee/info?id=' + ths.data.curEmpId + '&sign=' + window.$gloable
						.userinfo.sign).then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							data = data.data;
							let handle = data.handle;
							data = data.info;
							if (data.hasEmp) {
								if (!data.sameName && data.name1) {
									ths.data.handle.canCheckData1 = false;
								}
								if (data.diffDept) {
									ths.data.handle.canCheckData2 = false;
								}
								if (data.diffType) {
									ths.data.handle.canCheckData3 = false;
								}
							}
							switch (data.personType) {
								case 1:
									data.personTypeName = '员工';
									break;
								case 2:
									data.personTypeName = '保运';
									break;
								case 4:
									data.personTypeName = '外协';
									break;
								default:
									data.personTypeName = '其他';
									break;
							}
							switch (data.empType) {
								case 1:
									data.oldPersonTypeName = '员工';
									break;
								case 2:
									data.oldPersonTypeName = '保运';
									break;
								case 4:
									data.oldPersonTypeName = '外协';
									break;
								default:
									data.oldPersonTypeName = '其他';
									break;
							}
							ths.data.info = data;
							let pArr = data.doorPost.split(',');
							let arr = [];
							for (let i = 0; i < pArr.length; i++) {
								arr.push(Number(pArr[i]));
							}
							ths.data.handle.power = arr;
							ths.data.handle.passType = [1, 2];
							ths.data.handle.step = 0;
							ths.data.handle.img = handle.img;
							ths.data.handle.imgType = handle.imgType;

							{
								for (let i = 0; i < 2; i++) {
									for (let j = 0; j < ths.data.authorizeChecks[i].length; j++) {
										ths.data.authorizeChecks[i][j] = false;
									}
								}
							}

							let firstRow = ths.data.authorizeHeader;
							for (let prop in firstRow) {
								for (let i = 0; i < ths.data.handle.power.length; i++) {
									let p = '-' + ths.data.handle.power[i] + '-';
									if (prop.indexOf(p) > 0) {
										let idx = firstRow[prop];
										//authorizeChecks 0人脸 1CPU 2车辆
										//if (ths.data.info.hasVehicle && prop.indexOf('V') > 0) {
										//	ths.data.authorizeChecks[2][idx] = true;
										//} else {
										//if (ths.data.info.personType == 1) {
										ths.data.authorizeChecks[0][idx] = true;
										//ths.data.authorizeChecks[2][idx] = true;
										//} else {
										//	ths.data.authorizeChecks[1][idx] = true;
										//}
										//}
									}
								}
							}

							ths.data.handle.mobilePhone = handle.mobilePhone;
							ths.visible.handle = true;
							setTimeout(() => {
								ths.$refs.btnFinishCheckData.$el.focus();
							}, 100);
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
				} else {
					ths.$message.warning('请选择待办人员');
				}
			},
			cameraImage() {
				let ths = this;
				this.$refs.takeCamera.init();
			},
			loadLocationImage() {
				this.$refs.takeImage.init();
			},
			saveImage(img, type) {
				let ths = this;
				if (type == 'camera') {
					ths.data.handle.imgType = 0;
				} else if (type == 'location') {
					ths.data.handle.imgType = 1;
				}
				ths.blobToBase64(img).then(r => {
					ths.data.handle.img = r;
					ths.data.handle.imgType = 2;
				});
			},
			loadFaceSvcImage() {
				let ths = this;
				window.ax({
					mathod: 'get',
					url: 'api/v1/facesvc/getfaceimage?idno=' + ths.data.info.idno,
					responseType: 'blob'
				}).then(rsp => {
					const {
						data,
						headers
					} = rsp;
					const blob = new Blob([data], {
						type: headers['content-type']
					});
					ths.blobToBase64(blob).then(r => {
						ths.data.handle.img = r;
						ths.data.handle.imgType = 2;
					});
				}).catch(err => {
					console.log(err);
				});
			},
			toCropper() {
				let ths = this;
				this.$refs.takeImage.init();
				this.$refs.takeImage.setCurrentImage(ths.data.handle.img);
			},
			toFocusCardTxt() {
				let ths = this;
				ths.data.info.cardId = '';
				ths.data.info.cardNo = '';
				ths.$refs.txtCardId.focus();
			},
			blurCardTxt() {
				this.data.handle.cardTxtFocusStatus = false;
			},
			focusCardTxt() {
				this.data.handle.cardTxtFocusStatus = true;
			},
			handleCardChange(e) {
				e.target.blur();
				let ths = this;
				if (ths.data.handle.step == 2) {
					console.log('id:' + ths.data.info.cardId);
					console.log('no:' + ths.data.info.cardNo);
					if (ths.data.info.cardNo == '') {
						ths.$refs.txtCardId.blur();
						ths.$refs.txtCardNo.focus();
					} else {
						ths.$refs.txtCardNo.blur();
						this.finishReadCard();
					}
				}
			},
			finishCheckData() {
				let ths = this;
				ths.visible.loading = true;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					Id: ths.data.curEmpId,
					Idno: ths.data.info.idno,
					Image: ths.data.handle.img,
					SaveFaceSvc: ths.data.handle.saveFaceSvc
				};
				window.ax.post('api/rehandle/employee/savecardimage', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						if (ths.data.handle.onlyFace) {
							ths.data.info.cardNo = '';
							ths.data.info.cardId = '';
							ths.data.handle.step = 3;
						} else {
							ths.data.handle.step = 1;
						}
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.$message.error('执行脚本出错，请联系管理员');
					ths.visible.loading = false;
				});
			},
			finishPrint() {
				let ths = this;
				ths.data.handle.step = 2;
				setTimeout(() => {
					ths.data.info.cardNo = '';
					ths.data.info.cardId = '';
					ths.$refs.txtCardId.focus();
				}, 100);
			},
			finishReadCard() {
				let ths = this;
				ths.data.handle.step = 3;
				/*let firstRow = ths.data.authorizeHeader;
				if (ths.data.info.hasVehicle && ths.data.authorizeDatas.length == 3) {
					let row = { label: '车辆' };
					for (let c in firstRow) {
						row[c] = firstRow[c];
					}
					ths.data.authorizeDatas.push(row);
				} else if (!ths.data.info.hasVehicle && ths.data.authorizeDatas.length == 4) {
					ths.data.authorizeDatas.splice(3, 1);
				}*/
			},
			backToCheckData() {
				let ths = this;
				ths.data.handle.step = 0;
			},
			finishAuthorize() {
				let ths = this;
				ths.data.handle.step = 4;
			},
			backToReadCard() {
				let ths = this;
				if (ths.data.handle.onlyFace) {
					ths.data.handle.step = 1;
				} else {
					ths.data.handle.step = 2;
					setTimeout(() => {
						ths.data.info.cardNo = '';
						ths.data.info.cardId = '';
						ths.$refs.txtCardId.focus();
					}, 100);
				}
			},
			saveData() {
				let ths = this;
				ths.visible.loading = true;
				let authorizes = [];
				let h = ths.data.authorizeHeader;
				let d = ths.data.authorizeDatas[0];
				for (let c in h) {
					if (c != 'label') {
						let idx = h[c];
						let arr = c.split('-');
						for (let i = 0; i < arr.length; i++) {
							let groupNo = arr[i];
							if (groupNo != 'c' && groupNo != 'cV' && groupNo != '') {
								if (idx != undefined) {
									let check1 = ths.data.authorizeChecks[0][idx];
									let check2 = ths.data.authorizeChecks[1][idx];
									//let check3 = ths.data.authorizeChecks[2][idx];
									//let check4 = false;
									//if (ths.data.info.hasVehicle) {
									//	check4 = ths.data.authorizeChecks[2][idx];
									//}
									authorizes.push([groupNo, check1 ? 1 : 0, check2 ? 1 : 0, 0, 0]);
								}
							}
						}
					}
				}
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					Id: ths.data.curEmpId,
					Idno: ths.data.info.idno,
					Authorizes: authorizes,
					CardId: ths.data.info.cardId,
					CardNo: ths.data.info.cardNo,
					SaveFaceSvc: ths.data.handle.saveFaceSvc,
					Image: ths.data.handle.img,
					CanPos: ths.data.handle.canPos,
					CanMobilePos: ths.data.handle.canMobilePos,
					MobilePhone: ths.data.handle.mobilePhone,
					OnlyFace: ths.data.handle.onlyFace
				};
				window.ax.post('api/rehandle/employee/save', opt).then(rsp => {
					let data = rsp.data;
					ths.visible.loading = false;
					if (data.code == 1) {
						ths.search();
						ths.data.handle.step = 6;
					} else if (data.code == -4) {
						ths.backToReadCard();
					} else {
						ths.data.handle.step = 0;
						ths.$message.error(data.message);
					}
				}).catch(err => {
					console.log(err);
					ths.visible.loading = false;
				});
			},
			backToAuthorize() {
				let ths = this;
				ths.data.handle.step = 3;
			},
			changeCanPos(v) {
				if (v) {
					this.data.handle.canMobilePos = false;
				}
			},
			toPrint() {
				let ths = this;
				ths.visible.loading = true;
				window.ax.get('api/rehandle/employee/cardinfo?id=' + ths.data.info.personType + '&sign=' + window.$gloable
						.userinfo.sign, {})
					.then(rsp => {
						let data = rsp.data;
						if (data.code == 1) {
							ths.data.printFrameStatus.pic1IsComplate = false;
							//ths.data.printFrameStatus.pic2IsComplate = false;
							ths.data.print.noneprintbutton = true;
							setTimeout(() => {
								ths.visible.print = true;
								ths.data.print.template1 = data.data.html1.replace('@@empName@@', ths.data.info
										.name).replace('@@empCode@@', ths.data.info.code)
									.replace('@@deptName@@', ths.data.info.realDeptName).replace('@@idno@@',
										ths.data.info.idno)
									.replace('@@empName@@', ths.data.info.name);
								//ths.data.print.template2 = data.data.html2.replace('@@empName@@', ths.data.info.name).replace('@@empCode@@', ths.data.info.code)
								//									 .replace('@@deptName@@', ths.data.info.realDeptName).replace('@@idno@@', ths.data.info.idno)
								//									 .replace('@@empName@@', ths.data.info.name);
								let itl = setInterval(function() {
									if (ths.data.printFrameStatus.pic1IsComplate) {
										clearInterval(itl);
										ths.doPrint();
									}
								}, 100);
							}, 100)
						} else {
							ths.$message.error(data.message);
						}
						ths.visible.loading = false;
					}).catch(err => {
						ths.$message.error('执行脚本出错，请联系管理员');
						ths.visible.loading = false;
					});
			},
			backToPrint() {
				let ths = this;
				ths.data.handle.step = 1;
			},
			doPrint() {
				let ths = this;
				if (ths.$refs.pageBreak && ths.$refs.pageBreak.style["breakAfter"]) {
					ths.$refs.pageBreak.style["breakAfter"] = "";
					ths.$refs.pageBreak.style["pageBreakAfter"] = "always";
				}
				ths.$print(document.getElementById('printCardTemplate'), {
					noneGlobalStyle: true,
					callback: () => {
						setTimeout(function() {
							ths.visible.print = false;
							ths.data.print.noneprintbutton = false;
							ths.$message.success('打印完成');
							ths.addPrintNumber(ths.data.curEmpId);
							ths.finishPrint();
						}, 100);
					}
				});
			},
			backToAcsAuthorize() {
				let ths = this;
				ths.data.handle.step = 3;
			},
			blobToBase64(blob) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = e => {
						resolve(e.target.result);
					};
					reader.onerror = () => {
						reject(new Error('文件流异常'));
					}
					reader.readAsDataURL(blob);
				});
			},
			changeAuthorizeChecked(e) {
				let chked = e.target.checked;
				let pars = e.target.name.split('_');
				let row_idx = Number(pars[0]);
				let col_idx = Number(pars[1]);
				this.data.authorizeChecks[row_idx][col_idx] = chked;
			},
			removeApply() {
				let ths = this;
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					id: ths.data.curEmpId
				};
				ths.visible.loading = true;
				window.ax.post('api/rehandle/employee/removeapply', opt).then(rsp => {
					let data = rsp.data;
					if (data.code == 1) {
						ths.search();
						ths.$message.success(data.message);
					} else {
						ths.$message.error(data.message);
					}
					ths.visible.loading = false;
				}).catch(err => {
					console.log(err);
					ths.visible.loading = false;
				});
			},
			addPrintNumber(empId) {
				let opt = {
					Sign: window.$gloable.userinfo.sign,
					EmpId: empId
				};
				window.ax.post('api/personnal/employee/addprintnumber', opt);
			},
			checkPrintFramesStatus() {
				let ths = this;
				ths.data.printFrameStatus.checkAllComplateTimer = setInterval(function() {
					if (ths.visible.print) {
						let fPic1 = ths.$refs.template1;
						//let fPic2 = ths.$refs.template2;
						if (fPic1) {
							let cmp = fPic1.contentDocument.readyState == "complete";
							if (ths.data.printFrameStatus.pic1IsComplate != cmp) {
								ths.data.printFrameStatus.pic1IsComplate = cmp;
							}
						}
						//if (fPic2) {
						//	let cmp = fPic2.contentDocument.readyState == "complete";
						//	if (ths.data.printFrameStatus.pic2IsComplate != cmp) {
						//		ths.data.printFrameStatus.pic2IsComplate = cmp;
						//	}
						//}
					}
				}, 500);
			}
		},
		created() {
			let ths = this;
			ths.baseJS.initPower(ths.power);
			ths.api.loadDepartmentTree(ths, 'data.depts', 'visible.loading', function(){
				ths.api.loadAuthorizeGroup(ths, 'data.authorizeGroups', 'visible.loading', 1, d => {
					let row = {};
					var row1 = {
						label: '人脸'
					};
					var row2 = {
						label: '国密卡'
					};
					//var row4 = { label: '车辆' };
					var checks1 = [];
					var checks2 = [];
					//var checks4 = [];
					for (var i = 0; i < d.length; i++) {
						let item = d[i];
						let tId = item.topId;
						let id = 'c-' + item.id;
						let idV = 'cV-' + item.idV;
						row[id] = i;
						row[idV] = i;
						row1[id] = tId;
						row2[id] = tId;
						//row4[id] = tId;
						checks1[i] = false;
						checks2[i] = false;
						//checks4[i] = false;
					}
					ths.data.authorizeHeader = row;
					ths.data.authorizeDatas.push(row1);
					ths.data.authorizeDatas.push(row2);
					//ths.data.authorizeDatas.push(row4);
					ths.data.authorizeChecks.push(checks1);
					ths.data.authorizeChecks.push(checks2);
					//ths.data.authorizeChecks.push(checks4);
				});
			});
			ths.api.loadEmpHandleSetting(ths, 'setting', false);
			ths.checkPrintFramesStatus();
			ths.search(true);
		},
		mounted() {},
		components: {
			takeImage,
			takeCamera
		}
	}
</script>

<style>
	.red>>>input {
		color: red;
	}

	.ml10 {
		margin-left: 10px;
	}

	.handle-input {
		width: 200px;
		display: inline-block;
	}

	.handle-box {
		margin-bottom: 20px;
	}

	.left {
		float: left;
		margin-left: 10;
	}

	.right {
		float: right;
		margin-right: 10;
	}

	.handle-select {
		width: 120px;
	}

	.table {
		width: 100%;
		font-size: 14px;
	}

	.el-tree-node__content {
		height: 36px !important;
	}

	.dialog-footer {
		height: 30px;
	}

	.inner-authorize-table .el-checkbox.is-bordered.el-checkbox--large {
		padding: 2px 30px 7px 30px !important;
	}
</style>